/**
 * エラー発生時にAnalyticsへイベント通知
 **/
window.onerror = function(message, url, lineNum) {
  if ( !message || message == '' ) {
    return;
  }

  //無視して良いエラー
  if ( message == 'ResizeObserver loop limit exceeded' ){
    return;
  }


  /*
  if ( url ) { 
    message =  url + ":" + lineNum + " - "+ message + ",\n"+ "userAgent:" + window.navigator.userAgent;
  } else {
    message =  message + ",\n"+ "userAgent:" + window.navigator.userAgent;
  }
  */
  //console.log('on error');

  ga("send", "exception", { "exDescription": message });
  ga("all.send", "exception", { "exDescription": message });


  //Sentryへ送る
  //if ( Sentry ) { 
  //  Sentry.captureException(new Error(message));
  //}

};


//Sentryの初期化
/*
if ( typeof Sentry !== "undefined") { 
  Sentry.init({ dsn: 'https://c2edc39b71a946b8bfb9b4e27da57765@sentry.io/2855221' });
}
*/

